// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2ZWpL","inner":"Form_inner__1B5Tb","range":"Form_range__2HgBi","name":"Form_name__1SEz9","actions":"Form_actions__2zua6"};